export type {
    FetchLinkedSpacesAction,
    FetchLinkedSpacesSuccessAction,
    FetchLinkedSpacesFailureAction,
} from './linked-spaces';

export {
    FETCH_LINKED_SPACES,
    FETCH_LINKED_SPACES_SUCCESS,
    FETCH_LINKED_SPACES_FAILURE,
    fetchLinkedSpaces,
    fetchLinkedSpacesSuccess,
    fetchLinkedSpacesFailure,
} from './linked-spaces';
